import React from 'react'
import styled from 'styled-components'

import DefaultLayout, { LayoutProps } from '../default-layout/default-layout'
import { NavLink } from '../default-layout/nav.styles'
import { Container, Row } from '../grid'
import { ContentCol } from '../utilities'

import { Heading } from 'components/typography'
import getStyle from 'themes/getStyle'

interface Props extends LayoutProps {
  navItems?: Array<{
    label: string
    to: string
  }>
}

const Nav = styled(ContentCol)`
  margin-top: 2em;

  @media screen and (min-width: 768px) {
    margin-top: 6.5em;
  }
`

const Article = styled.article`
  max-width: ${getStyle('articleWidth')};
  margin-top: 1.5em;

  ${Heading} {
    margin-bottom: 2rem;
  }

  @media screen and (min-width: 768px) {
    margin-left: auto;
    margin-right: auto;
  }
`

const ArticleLayout = ({ navItems = [], children, ...props }: Props) => {
  return (
    <DefaultLayout {...props}>
      <Container>
        <Row cols="1:3">
          <div>
            <Nav as="nav">
              {navItems.map((item, key) => {
                return (
                  <NavLink to={item.to} key={key} activeClassName="active">
                    {item.label}
                  </NavLink>
                )
              })}
            </Nav>
          </div>

          <div>
            <Article>
              <Heading as="h1">{props.title}</Heading>
              {children}
            </Article>
          </div>
        </Row>
      </Container>
    </DefaultLayout>
  )
}

export default ArticleLayout
